import { VehicleType } from "@daytrip/legacy-enums";
import { Expose } from "class-transformer";
import { IsDefined, IsEnum, IsNumber } from "class-validator";

import { GField, GInt, GObjectType, GInputType } from "../graphql";
import { CDColumn } from "../orm";

@GObjectType("SimpleVehicleTypeCoefficient")
@GInputType("SimpleVehicleTypeCoefficientInput")
export class VehicleTypeCoefficient {
    @CDColumn()
    @IsEnum(VehicleType)
    @Expose()
    @GField(() => GInt)
    @IsDefined()
    public vehicleType: VehicleType;

    @CDColumn()
    @IsNumber()
    @Expose()
    @GField()
    @IsDefined()
    public priceAdjustmentCoefficient: number;

    @CDColumn()
    @IsNumber()
    @Expose()
    @GField()
    @IsDefined()
    public feeAdjustmentCoefficient: number;

    @CDColumn()
    @IsNumber()
    @Expose()
    @GField()
    @IsDefined()
    public cutoffInHours: number;
}
